import { RpcInterceptor } from "@protobuf-ts/runtime-rpc";

import { transport } from "../../../api/grpc/grpcTransport";
import { CheckoutItem } from "../../../api/grpc/subscription/subscription";
import { ChargeBeeHostedServiceClient } from "../../../api/grpc/subscription/subscription.client";

/**
 * Creates a Chargebee hosted checkout for one-time items, such as the
 * Product Store cart. Unlike `createHostedPage`, errors are thrown so the
 * caller can show them.
 */
export const createOneTimeCheckout = async (
  customerID: string,
  interceptor: RpcInterceptor,
  items: CheckoutItem[]
) => {
  const hostedServiceClient = new ChargeBeeHostedServiceClient(transport);

  const { response } = await hostedServiceClient.createOneTimeCheckout(
    { customerID, items },
    { interceptors: [interceptor] }
  );

  return response;
};
